<div class="ui-task-progress-bar__title ui-caption" data-cy="task-progress-bar-title">
  <span class="ui-body-2" data-cy="task-progress-bar-title-total">{{ total }}</span> {{ text }}
</div>
<campus-progress
  class="ui-task-progress-bar__progress"
  [form]="forms.LINEAR"
  [count]="amount"
  [total]="total"
  data-cy="task-progress-bar-progress"
></campus-progress>
<div class="ui-task-progress-bar__values ui-label" data-cy="task-progress-bar-progress-amount"
  >{{ amount }}/{{ total }}</div
>
